import { Toast, Dialog } from "vant";

// 去空格
export function trimAll(string: any) {
    if (!string) {
        return string
    } else {
        return  string.replace(/\s/g, "")
    }
}

// loading窗口
export function loading(message: string) {
    return Toast.loading({
        duration: 0,
        forbidClick: true,
        message,
    })
}

// 截取文字
export function cutWord(str: string, num: number = 10) {
    if (!str) {
        return ''
    }
    if (str.length <= num) {
        return str
    } else {
        return str.substring(0, num) + '...'
    }
}

// 错误弹窗
export function message(message: string) {
    return Dialog.alert({
        message,
        title: '提示',
        confirmButtonColor: '#FF8A49',
        className: 'jp_error_dialog',
        confirmButtonText: '我知道了'
    })
}
